import React from 'react'

export const StatusLegend: React.FC = () => {
  return (
    <div className="glass-panel rounded-2xl p-6">
      <h3 className="text-lg font-semibold mb-4">Обозначение статусов</h3>
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 rounded-full bg-emerald-500" />
          <span>Работает</span>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 rounded-full bg-amber-500" />
          <span>Проблемы</span>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 rounded-full bg-rose-500" />
          <span>Не работает</span>
        </div>
      </div>
    </div>
  )
}